// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.titleText {
    font-size: 20px;
    font-weight: bold;
    color: black;
}

.infoText {
    font-size: 15px;
    color: #A8A8A8;
}

.spanRow {
    flex: 1 1;
    flex-direction: row;
    display: flex;
    width: 80vw;
    justify-content: space-between;
    margin-top: 20px;
    margin-right: 3px;
    margin-left: 3px;
    margin-bottom: 15px;
}

.loginContent {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: flex-start;
    align-self: flex-start;
    margin-left: 33px;
    margin-right: 33px;
    width: calc(100% - 69px);
}

.mainLogin {
    width: 100%;
    flex: 1 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    min-height: 100%;
    margin-top: 60px;
    margin-bottom: 60px;
}

.textHelp {
    background-color: white;
    border-radius: 8px;
    padding: 10px;
    width: 90%;
    color: #858383;
}

.helpBtn {
    padding: 5px;
    width: 90%;
    background-color: #D02030;
    border-radius: 8px;
    justify-content: space-between;
    align-items: center;
    display: flex;
    cursor: pointer;
    height: 33px;
    font-weight: bold;
    flex-direction: row;
    margin-top: 30px;
    margin-bottom: 10px;
}

.needHelp {
    padding: 5px;
    width: 40%;
    background-color: #D02030;
    border-radius: 8px;
    justify-content: space-between;
    align-items: center;
    display: flex;
    cursor: pointer;
    height: 33px;
    font-weight: bold;
    flex-direction: row;
    margin-top: 130px;

}

.btnText {
    margin-left: 25px;
    color: white;
    font-weight: bold;
}

.arrow {
    margin-right: 25px;
}

.helpBtn:hover {
    background-color: #D02030;
    opacity: 1;
}

.needHelp:hover {
    background-color: #D02030;
    opacity: 1;
}

#faq {
    display: block;
    height: 20px;
    margin-left: 7px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Login/login.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,2BAA2B;IAC3B,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,SAAO;IACP,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;;AAErB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;AACpB","sourcesContent":[".titleText {\n    font-size: 20px;\n    font-weight: bold;\n    color: black;\n}\n\n.infoText {\n    font-size: 15px;\n    color: #A8A8A8;\n}\n\n.spanRow {\n    flex: 1;\n    flex-direction: row;\n    display: flex;\n    width: 80vw;\n    justify-content: space-between;\n    margin-top: 20px;\n    margin-right: 3px;\n    margin-left: 3px;\n    margin-bottom: 15px;\n}\n\n.loginContent {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    justify-content: flex-start;\n    align-self: flex-start;\n    margin-left: 33px;\n    margin-right: 33px;\n    width: calc(100% - 69px);\n}\n\n.mainLogin {\n    width: 100%;\n    flex: 1;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-direction: column;\n    min-height: 100%;\n    margin-top: 60px;\n    margin-bottom: 60px;\n}\n\n.textHelp {\n    background-color: white;\n    border-radius: 8px;\n    padding: 10px;\n    width: 90%;\n    color: #858383;\n}\n\n.helpBtn {\n    padding: 5px;\n    width: 90%;\n    background-color: #D02030;\n    border-radius: 8px;\n    justify-content: space-between;\n    align-items: center;\n    display: flex;\n    cursor: pointer;\n    height: 33px;\n    font-weight: bold;\n    flex-direction: row;\n    margin-top: 30px;\n    margin-bottom: 10px;\n}\n\n.needHelp {\n    padding: 5px;\n    width: 40%;\n    background-color: #D02030;\n    border-radius: 8px;\n    justify-content: space-between;\n    align-items: center;\n    display: flex;\n    cursor: pointer;\n    height: 33px;\n    font-weight: bold;\n    flex-direction: row;\n    margin-top: 130px;\n\n}\n\n.btnText {\n    margin-left: 25px;\n    color: white;\n    font-weight: bold;\n}\n\n.arrow {\n    margin-right: 25px;\n}\n\n.helpBtn:hover {\n    background-color: #D02030;\n    opacity: 1;\n}\n\n.needHelp:hover {\n    background-color: #D02030;\n    opacity: 1;\n}\n\n#faq {\n    display: block;\n    height: 20px;\n    margin-left: 7px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
